export const environment = {
  production: true,
  hmr: false,
  s3BucketHostUrl: '',
  amplitudeKey: '',
  appEnvironment: 'production',
  gaKey: '',
  reportServer: '',
  apiUrl: 'https://demo-api.branzee.app',
  httpTimeout: 60000,
};
// ng build --configuration development

// api dev  https://api-dev.branzee.app
// api demo  https://demo-api.branzee.app
// api prod  https://api.branzee.app
